// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M497,2057.06333 C493.252,2057.47933 490,2060.64133 490,2064.5 C490,2068.64133 493.357333,2072 497.5,2072 C501.359333,2072 504.52,2068.74733 504.936667,2065 L497,2065 L497,2057.06333 Z M498,2056 L498,2064 L506,2064 C505.716667,2059.70867 502.292,2056.28333 498,2056 Z", transform: "translate(-490 -2056)" })))));
};
Icon.displayName = 'ChartPie16x16';
export default Icon;
//# sourceMappingURL=ChartPie16x16.js.map